import { render, staticRenderFns } from "./FixedShell.vue?vue&type=template&id=224c844d&scoped=true"
import script from "./FixedShell.vue?vue&type=script&lang=js"
export * from "./FixedShell.vue?vue&type=script&lang=js"
import style0 from "./FixedShell.vue?vue&type=style&index=0&id=224c844d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224c844d",
  null
  
)

export default component.exports